import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./EstimateIndia.css";
import image4 from "../../../images/EstimateCertified.png";
import image5 from "../../../images/EstimateCMP.png";
import "@fortawesome/fontawesome-free/css/all.min.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";
import QuillBetterTable from "quill-better-table";
import "quill-better-table/dist/quill-better-table.css";
import Loader from "../../../components/Loader/loader";
import html2pdf from "html2pdf.js";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import SendMailWithPdf from "../../../components/SendMailWithPdf/SendMailWithPdf";

ReactQuill.Quill.register(
  {
    "modules/better-table": QuillBetterTable,
  },
  true
);

const EstimateIndia = () => {
  const location = useLocation();
  const baseAPI = process.env.REACT_APP_API_URL;
  const [data, setData] = useState([]); // Store fetched data
  const [loading, setLoading] = useState(false); // For loading state
  const [error, setError] = useState(null); // For error state
  const [sow, setSow] = useState([]);
  const [decryptionError, setDecryptionError] = useState(false);

  const [paymentLink, setPaymentLink] = useState("");
  const [showEmailModal, setShowEmailModal] = useState(false);
  const openModal = () => setShowEmailModal(true);
  const closeModal = () => setShowEmailModal(false);

  const [showEmailModalPayLink, setShowEmailModalPayLink] = useState(false);
  const openModalLink = () => setShowEmailModalPayLink(true);
  const closeModalLink = () => setShowEmailModalPayLink(false);

  const [emailData, setEmailData] = useState({
    mail_to: "",
    mail_subject: "",
    mail_body: "",
  });
  const [emailDataPayLink, setEmailDataPayLink] = useState({
    mail_to: "",
    mail_subject: "",
    mail_body: "",
    Payement_requested: "",
    paymentgatewayCharges: "",
    total_payment: "",
    remark: "",
  });

  const [relDetail, setRelDetail] = useState({
    relocation_id: 0,
    first_name: "",
    Number_Of_Pets: 0,
    job_type: "",
    mode: "",
    delivery_type: "",
    estimate_id: "",
    created_date: "",
    expiry_date: "",
    modified_by: "",
    place_of_supply: "",
    origin_city: "",
    destination_city: "",
    bill_to: "",
    ship_to: "",
    airline_name: "",
    origin_location: "",
    destination_location: "",
    Vol_Weight: "",
    crate_size: "",
    total_amount_aed: "",
    totalAmountWithTax: "",
    discount: "",
    Email: "",
    ServiceTypeName: "",
  });

  const queryParams = new URLSearchParams(location.search);
  const encryptedRelocationID = queryParams.get("Relocation_ID"); // Get from URL
  const relocation_id = encryptedRelocationID
    ? decryptRelocationID(encryptedRelocationID)
    : null;

  function decryptRelocationID(ciphertext) {
    try {
      if (!ciphertext) {
        console.warn("No ciphertext provided for decryption");
        return null;
      }

      const decoded = decodeURIComponent(ciphertext);
      const bytes = CryptoJS.AES.decrypt(decoded, "dbbworldwidepvtltd");

      if (!bytes || bytes.sigBytes <= 0) {
        console.error("Decryption failed, invalid data");
        return null;
      }

      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      return null;
    }
  }

  const handlePaymentRequestedChange = (e) => {
    const paymentRequested =
      typeof e === "number" ? e : parseFloat(e.target.value) || 0;
    const totalPayment = paymentRequested / 0.958;
    const gatewayCharges = totalPayment * 0.042;

    setEmailDataPayLink((prevData) => ({
      ...prevData,
      Payement_requested: paymentRequested,
      total_payment: totalPayment.toFixed(2),
      paymentgatewayCharges: gatewayCharges.toFixed(2),
    }));
  };

  const numberToWords = (num) => {
    const units = [
      "Zero",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const thousands = ["", "Thousand", "Million", "Billion"];

    // 🚨 Guard: handle invalid numbers
    if (num == null || num === "" || isNaN(num)) {
      return "";
    }

    num = Number(num);

    if (num === 0) return "Zero";

    const convertToWords = (n) => {
      if (n < 10) return units[n];
      if (n < 20) return teens[n - 10];
      if (n < 100)
        return tens[Math.floor(n / 10)] + (n % 10 ? " " + units[n % 10] : "");
      if (n < 1000) {
        return (
          units[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 ? " " + convertToWords(n % 100) : "")
        );
      }
      for (let i = 0; i < thousands.length; i++) {
        const unit = 1000 ** i;
        if (n < unit * 1000) {
          return (
            convertToWords(Math.floor(n / unit)) +
            " " +
            thousands[i] +
            (n % unit ? " " + convertToWords(n % unit) : "")
          );
        }
      }
    };

    // ✅ Handle decimals safely
    if (!Number.isInteger(num)) {
      let [integerPart, decimalPart] = num.toString().split(".");
      let decimalWords = decimalPart
        .split("")
        .map((digit) => units[parseInt(digit)])
        .join(" ");
      return `${convertToWords(parseInt(integerPart))} Point ${decimalWords}`;
    }

    return convertToWords(num);
  };

  // Fetch APIs
  useEffect(() => {
    const fetchData = async () => {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      if (!storedToken || !relocation_id) return;

      setLoading(true);

      try {
        // First API: Get relocation detail
        const detailRes = await axios.get(
          `${baseAPI}userget/GetSOWRelocationDetailNew?relocation_id=${relocation_id}`,
          { headers: { Authorization: `Bearer ${storedToken}` } }
        );

        setRelDetail(detailRes.data.data || {});
        // Second API: Get India SOW
        const sowRes = await axios.get(
          `${baseAPI}userget/GetSOWIndia?relocation_id=${relocation_id}`,
          { headers: { Authorization: `Bearer ${storedToken}` } }
        );

        setSow(sowRes.data.data || {});
      } catch (err) {
        setError("Error fetching data.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [baseAPI, relocation_id]);

  useEffect(() => {
    if (relDetail) {
      getMailTemplate(1);
      getMailTemplate(2);
    }
  }, [relDetail]);

  //GetSOWIndia
  function getGetCMP() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}userget/GetSOWIndia?relocation_id=${relocation_id}`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setSow(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getMailTemplate(mail_template_id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}userget/GetEmailTemplate?mail_template_id=${mail_template_id}&options=null`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      )
      .then((res) => {
        if (mail_template_id === 1) {
          setEmailData({ ...res.data.data, mail_to: relDetail.Email });
        } else if (mail_template_id === 2) {
          const updatedMailSubject = `Carry My Pet // Payment Link for Your Booking - Lead ID :${relDetail.relocation_id} || ${relDetail.first_name}`;
          setEmailDataPayLink({
            ...res.data.data,
            mail_to: relDetail.Email,
            Payement_requested: relDetail.totalAmountWithTax,
            mail_subject: updatedMailSubject,
          });
          handlePaymentRequestedChange(relDetail.totalAmountWithTax);
        }
      })
      .catch((err) => console.error("Error fetching email template", err));
  }

  const SavePdfSendMail = async (mail_type) => {
    setLoading(true);

    document.body.classList.add("pdf-mode");

    try {
      const invoiceElement = document.getElementById("invoiceContent");
      const termsElement = document.getElementById("termsContent");

      // if (headerLogo2) {
      //   headerLogo2.style.display = "flex"; // Show logo for PDF
      // }

      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 190;
      const pageHeight = 297;
      let yPosition = 10;

      // Convert Invoice Content to Image
      const invoiceCanvas = await html2canvas(invoiceElement, { scale: 2 });
      const invoiceImgData = invoiceCanvas.toDataURL("image/jpeg");
      const invoiceImgHeight =
        (invoiceCanvas.height * imgWidth) / invoiceCanvas.width;

      pdf.addImage(
        invoiceImgData,
        "JPEG",
        10,
        yPosition,
        imgWidth,
        invoiceImgHeight
      );
      addFooter(pdf);

      if (invoiceImgHeight + yPosition > pageHeight - 20) {
        pdf.addPage();
        yPosition = 10;
      } else {
        yPosition += invoiceImgHeight + 10;
      }

      // Convert Terms & Conditions to Image
      const termsCanvas = await html2canvas(termsElement, { scale: 2 });
      const termsImgData = termsCanvas.toDataURL("image/jpeg");
      const termsImgHeight =
        (termsCanvas.height * imgWidth) / termsCanvas.width;

      pdf.addPage();
      pdf.addImage(termsImgData, "JPEG", 10, 10, imgWidth, termsImgHeight);
      addFooter(pdf);

      if (mail_type === 0) {
        pdf.save("Estimate.pdf");
      }

      // Convert PDF to Blob
      const pdfBlob = pdf.output("blob");

      // Prepare FormData
      const formData = new FormData();
      formData.append("pdfFile", pdfBlob, `${relocation_id}_Estimate.pdf`);
      formData.append("relocation_id", relocation_id);
      formData.append("mail_type", mail_type);

      const storedToken = JSON.parse(localStorage.getItem("token"));
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        "Content-Type": "multipart/form-data",
      };

      if (mail_type === 0) {
        await axios.post(`${baseAPI}userpost/SaveQuotation`, formData, {
          headers,
        });
        toast.success("Quotation Downloaded!!", {
          position: "top-right",
          autoClose: 2000,
        });
      } else if (mail_type === 1) {
        // Send Email
        formData.append("mail_to", emailData.mail_to);
        formData.append("mail_body", emailData.mail_body);
        formData.append("mail_subject", emailData.mail_subject);

        await axios.post(`${baseAPI}userpost/SavePdfSendMail`, formData, {
          headers,
        });
        if (typeof closeModal === "function") closeModal();
        toast.success("Mail Sent Successfully!!", {
          position: "top-right",
          autoClose: 2000,
        });
      } else if (mail_type === 2) {
        // Generate Payment Link
        const total_payment = Number(emailDataPayLink.total_payment) || 0;
        const remark = emailDataPayLink.remark || "0";

        const paymentResponse = await axios.post(
          `${baseAPI}Payment/GeneratePaymentLink`,
          { relocation_id, total_payment, remark },
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (paymentResponse.data && paymentResponse.data.data) {
          setPaymentLink(paymentResponse.data.data);
          formData.append("paymentLink", paymentResponse.data.data);
        }

        // Send Payment Email
        formData.append("mail_to", emailDataPayLink.mail_to);
        formData.append("mail_body", emailDataPayLink.mail_body);
        formData.append("mail_subject", emailDataPayLink.mail_subject);
        formData.append(
          "Payement_requested",
          emailDataPayLink.Payement_requested
        );
        formData.append(
          "paymentgatewayCharges",
          emailDataPayLink.paymentgatewayCharges
        );
        formData.append("total_payment", emailDataPayLink.total_payment);

        await axios.post(`${baseAPI}userpost/SavePdfSendPayLink`, formData, {
          headers,
        });
        if (typeof closeModalLink === "function") closeModalLink();
        toast.success("Mail Sent Successfully!!", {
          position: "top-right",
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        "Failed to send mail and download document. Please try again.",
        { position: "top-right", autoClose: 2000 }
      );
    } finally {
      document.body.classList.remove("pdf-mode"); // cleanup      
      setLoading(false);
    }
  };

  const addFooter = (pdf) => {
    const pageHeight = 297; // A4 page height in mm
    const footerHeight = 20; // Adjusted footer height
    const footerY = pageHeight - footerHeight + 5; // Footer position with padding

    pdf.setFontSize(10);
    pdf.setTextColor(255, 255, 255); // White text for dark background

    // Background Color (Extend the height for better spacing)
    pdf.setFillColor(91, 72, 157); // #5b489d
    pdf.rect(0, footerY - 5, 210, footerHeight + 5, "F"); // Increased height for better padding

    // Add paragraph text ABOVE footer
    pdf.setFontSize(8);
    pdf.setTextColor(0, 0, 0); // Black color for paragraph text
    pdf.text(
      "This estimate is electronically generated and does not require a signature",
      105,
      footerY - 8, // Adjusted position for better spacing
      { align: "center" }
    );

    // Footer Content
    pdf.setFontSize(9.8);
    pdf.setTextColor(255, 255, 255); // White text
    const textPaddingY = 3; // Extra padding for alignment

    pdf.text("enquiry@carrymypet.com", 10, footerY + textPaddingY);
    pdf.text("+91 8908909020", 95, footerY + textPaddingY);

    // Website links (Right-aligned)
    const textWidth1 = pdf.getTextWidth("www.carrymypet.com");
    const textWidth2 = pdf.getTextWidth("www.carrymypet.ae");

    pdf.text("www.carrymypet.com", 200 - textWidth1, footerY + textPaddingY);
    pdf.text("www.carrymypet.ae", 200 - textWidth2, footerY + textPaddingY + 5); // Move second URL 5mm down
  };

  const hasDiscount =
    relDetail?.total_discount !== null &&
    relDetail?.total_discount !== undefined &&
    relDetail?.total_discount !== "" &&
    relDetail?.total_discount !== "0" &&
    relDetail?.total_discount !== 0;

  const hasAdjustment =
    !!relDetail?.adjustment && parseFloat(relDetail.adjustment) !== 0;

const hasGetwayCharge =
    !!relDetail?.paymentGatewayCharges && parseFloat(relDetail.paymentGatewayCharges) !== 0;



  return (
    <>
      <div className="app-container-LeadList estimate-page-colSize">
        <MiniDrawer />
        <div
          className="container-fluid container-viewLeadDetails"
          style={{ padding: "6rem 1rem 1rem 1rem " }}
        >
          {loading && (
            <div className="loader-overlay">
              <Loader />
            </div>
          )}
          <ToastContainer />
          <div className="country-header">
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                <b> Scope of Work </b> | <HomeOutlinedIcon /> &gt;
                <span style={{ fontSize: "20px" }}>&gt; Estimate</span>
              </h1>
            </div>
          </div>
          <Wrapper className="LeadDetails">
            {/* ----------------------------------Quotation builder-------------------------------- */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div></div>
              <div style={{ marginTop: "-1rem" }}>
                <button
                  onClick={() => SavePdfSendMail(0)}
                  className="btn btn-primary  edit-Button-off"
                  style={{
                    margin: "1rem 1rem 0rem 0rem",
                    width: "auto",
                  }}
                >
                  Publish to PDF
                </button>
                {/* <button
                  style={{ width: "auto" }}
                  className={"btn btn-primary edit-Button-off"}
                  onClick={openModal}
                >
                  Send Mail For Estimate
                </button>
                <button
                  style={{ width: "auto" }}
                  className={"btn btn-primary edit-Button-off"}
                  onClick={openModalLink}
                >
                  Send Mail For with Payment link
                </button> */}
              </div>
            </div>
          </Wrapper>
        </div>
      </div>
      <div>
        <div>
          {showEmailModal && (
            <div className="mukulcode1">
              <div className="mukulcode2">
                <div>
                  <h3>Send Estimate Email</h3>
                  <label className="mukulcode3">Mail To:</label>
                  <input
                    className="mukulcode4"
                    type="text"
                    value={emailData.mail_to}
                    onChange={(e) =>
                      setEmailData({ ...emailData, mail_to: e.target.value })
                    }
                  />
                  <label className="mukulcode3">Subject:</label>
                  <input
                    className="mukulcode4"
                    type="text"
                    value={emailData.mail_subject}
                    onChange={(e) =>
                      setEmailData({
                        ...emailData,
                        mail_subject: e.target.value,
                      })
                    }
                  />
                  <label className="mukulcode3">Body:</label>
                  <div className="mukulcode8">
                    <ReactQuill
                      className="mukulcode9"
                      theme="snow"
                      value={emailData.mail_body}
                      onChange={(value) =>
                        setEmailData({ ...emailData, mail_body: value })
                      }
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, false] }],
                          ["bold", "italic", "underline"],
                          [{ list: "ordered" }, { list: "bullet" }],
                          ["link"],
                          [{ align: [] }],
                          ["table"],
                        ],
                      }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <button
                    className="mukulcodeButton1"
                    onClick={() => SavePdfSendMail(1)}
                  >
                    Send Mail
                  </button>
                  <button className="mukulcodeButton2" onClick={closeModal}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          {showEmailModalPayLink && (
            <div className="mukulscode1">
              <div className="mukulscode2">
                <h3 className="mukulscode3">
                  Send Estimate Email with Payment Link
                </h3>
                <div className="row">
                  <div className="col-6">
                    <label className="mukulscode4">Mail To:</label>
                    <input
                      className="mukulscode5"
                      type="text"
                      value={emailDataPayLink.mail_to}
                      onChange={(e) =>
                        setEmailDataPayLink({
                          ...emailDataPayLink,
                          mail_to: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-6">
                    <label className="mukulscode4">Subject:</label>
                    <input
                      className="mukulscode5"
                      type="text"
                      value={emailDataPayLink.mail_subject}
                      onChange={(e) =>
                        setEmailDataPayLink({
                          ...emailDataPayLink,
                          mail_subject: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-6">
                    <label className="mukulscode4">Payment Requested:</label>
                    <input
                      className="mukulscode5"
                      type="text"
                      value={emailDataPayLink.Payement_requested}
                      onChange={handlePaymentRequestedChange}
                    />
                  </div>
                  <div className="col-3">
                    <label className="mukulscode4">
                      Payment Gateway Charges:
                    </label>
                    <label className="mukulscode12-1">
                      {emailDataPayLink.paymentgatewayCharges}
                    </label>
                  </div>
                  <div className="col-3">
                    <label className="mukulscode4">Total Payment:</label>
                    <label className="mukulscode14">
                      {emailDataPayLink.total_payment}
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <label className="mukulscode4">Remark:</label>
                    <input
                      className="mukulscode5"
                      type="text"
                      value={emailDataPayLink.remark}
                      onChange={(e) =>
                        setEmailDataPayLink({
                          ...emailDataPayLink,
                          remark: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="mukulscode8">
                  <ReactQuill
                    className="mukulscode9"
                    theme="snow"
                    value={emailDataPayLink.mail_body}
                    onChange={(value) =>
                      setEmailDataPayLink({
                        ...emailDataPayLink,
                        mail_body: value,
                      })
                    }
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        ["bold", "italic", "underline"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link"],
                        [{ align: [] }],
                        ["table"],
                      ],
                    }}
                  />
                </div>
                <div className="mukulscode15">
                  <button
                    className="mukulscode15-1"
                    onClick={() => SavePdfSendMail(2)}
                    style={{}}
                  >
                    Send Mail
                  </button>
                  <button
                    className="mukulscode16"
                    onClick={closeModalLink}
                    style={{}}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* {showEmailModalPayLink && (
            <SendMailWithPdf relocation_id={"56231"} email={"ankur@gmail.com"} Quotation={"12345"} first_name={"Arun Srivastava"} setShowEmailModalPayLink={setShowEmailModalPayLink} lead_owner={"dev@carrymypet.com"} />
          )} */}
          <br />

        </div>
        <div>
          <div
            style={{ border: "1px solid grey" }}
            className="estimate-container"
          >
            <div id="pdf-content" className="estimate-container">
              <div id="invoiceContent">
                <div className="header1">
                  <div className="billing-details billing-details-bottom">
                    <div className="left Estimate-leftP">
                      <h1>ESTIMATE</h1>
                      <p>
                        <strong>Estimate No</strong>: {relDetail?.estimate_id}
                      </p>
                      <p>
                        <strong>Estimate Date</strong> :{" "}
                        {relDetail?.estimate_date
                          ? new Date(relDetail.estimate_date).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                          : "-"}
                      </p>
                      <p>
                        <strong>Expiry Date </strong> :{" "}
                        {relDetail.expiry_date
                          ? new Date(relDetail.expiry_date).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                          : "-"}

                      </p>
                      <p>
                        <strong>Est Created By:</strong> {relDetail.estimate_created_by}
                      </p>
                    </div>
                  </div>
                  <div className="header-right">
                    <div
                      className="logo-container logo-container-wigth"
                      style={{ width: "278px" }}
                    >
                      <img
                        style={{
                          width: "14pc",
                          height: "129px",
                          marginLeft: "38px",
                        }}
                        src={image5}
                        alt="Logo"
                        className="logo logo-container-wigth-img"
                      />
                    </div>
                    <p
                      style={{
                        marginBottom: "-13px",
                        fontSize: "8px",
                        padding: "4px",
                        fontWeight: "700",
                      }}
                    >
                      Certified by:
                    </p>
                    <img
                      style={{ width: "10pc", padding: "5px" }}
                      src={image4}
                      alt="Certification"
                      className="certification logo-container-wigth-img1"
                    />
                  </div>
                </div>

                <div className="estimate-details-container">
                  <div className="details-column border-right">
                    <div className="TrBackColor TrBackColor-EM">
                      <span className="fontweightbold">Lead ID</span> :{" "}
                      <span className="fontweightbold fontweightbold-EM">
                        {" "}
                        {relDetail.relocation_id}
                      </span>
                    </div>
                    <div className="TrBackColor TrBackColor-EM">
                      <span className="fontweightbold">Pet Owner Name</span> :{" "}
                      <span className="fontweightbold fontweightbold-EM">
                        {relDetail.name}{" "}
                      </span>
                    </div>
                    <div className="TrBackColor TrBackColor-EM">
                      <span className="fontweightbold">Pet Type & Count</span> :{" "}
                      <span className="fontweightbold fontweightbold-EM">
                        {" "}
                        {relDetail.pettype} | {relDetail.number_of_pets}
                        {/* |{" "}
                        {relDetail.Number_Of_Pets} */}
                      </span>
                    </div>
                    <div className="TrBackColor TrBackColor-EM">
                      <span className="fontweightbold">Service Type</span> :{" "}
                      <span className="fontweightbold fontweightbold-EM">
                        {relDetail.ServiceTypeName}{" "}
                      </span>
                    </div>
                    <div className="TrBackColor TrBackColor-EM">
                      <span className="fontweightbold">Delivery Type</span> :{" "}
                      <span className="fontweightbold fontweightbold-EM">
                        {relDetail.delivery_type_name}
                      </span>
                    </div>
                    <div className="TrBackColor TrBackColor-EM">
                      <span className="fontweightbold">Amount in AED</span> :{" "}
                      <span className="fontweightbold fontweightbold-EM">
                        {relDetail.amount_in_aed}
                      </span>
                    </div>
                  </div>

                  <div className="details-column border-left">
                    <div className="TrBackColor TrBackColor-EM">
                      <span className="fontweightbold">
                        {relDetail.mode_of_transport_name === "Air"
                          ? "Origin City & Airport"
                          : relDetail.mode_of_transport_name === "Road"
                            ? "Origin City & Location"
                            : relDetail.mode_of_transport_name === "Train"
                              ? "Origin City & Station"
                              : "Origin City"}
                      </span>{" "}
                      :{" "}
                      <span className="fontweightbold fontweightbold-EM">
                        {relDetail.origin_city1}
                        {relDetail.mode_of_transport_name === "Air" &&
                          relDetail.origin_airport
                          ? ` | ${relDetail.origin_airport}`
                          : ""}
                        {relDetail.mode_of_transport_name === "Road" &&
                          relDetail.origin_address
                          ? ` | ${relDetail.origin_address}`
                          : ""}
                        {relDetail.mode_of_transport_name === "Train" &&
                          relDetail.origin_station
                          ? ` | ${relDetail.origin_station}`
                          : ""}
                      </span>
                    </div>

                    <div className="TrBackColor TrBackColor-EM">
                      <span className="fontweightbold">
                        {relDetail.mode_of_transport_name === "Air"
                          ? "Destination City & Airport"
                          : relDetail.mode_of_transport_name === "Road"
                            ? "Destination City & Location"
                            : relDetail.mode_of_transport_name === "Train"
                              ? "Destination City & Station"
                              : "Destination City"}
                      </span>{" "}
                      :{" "}
                      <span className="fontweightbold fontweightbold-EM">
                        {relDetail.destination_city1}
                        {relDetail.mode_of_transport_name === "Air" &&
                          relDetail.destination_airport
                          ? ` | ${relDetail.destination_airport}`
                          : ""}
                        {relDetail.mode_of_transport_name === "Road" &&
                          relDetail.destination_address
                          ? ` | ${relDetail.destination_address}`
                          : ""}
                        {relDetail.mode_of_transport_name === "Train" &&
                          relDetail.destination_station
                          ? ` | ${relDetail.destination_station}`
                          : ""}
                      </span>
                    </div>

                    <div className="TrBackColor TrBackColor-EM">
                      <span className="fontweightbold">
                        {relDetail.mode_of_transport_name === "Air"
                          ? "Mode & Airline Name"
                          : relDetail.mode_of_transport_name === "Road"
                            ? "Mode"
                            : relDetail.mode_of_transport_name === "Train"
                              ? "Mode"
                              : "Mode"}
                      </span>{" "}
                      :{" "}
                      <span className="fontweightbold fontweightbold-EM">
                        {relDetail.mode_of_transport_name}
                        {relDetail.mode_of_transport_name === "Air" && relDetail.airline_name
                          ? ` | ${relDetail.airline_name}`
                          : ""}
                        {relDetail.mode_of_transport_name === "Road"}
                        {relDetail.mode_of_transport_name === "Train"}
                      </span>
                      {/* In Future  */}
                      {/* {relDetail.mode === "Air" ? "Mode & Airline Name" : relDetail.mode === "Road" ? "Mode & Vehicle Name" : relDetail.mode === "Train" ? "Mode & Train Name" : "Mode"} </span>{" "} :{" "} <span className="fontweightbold fontweightbold-EM"> {relDetail.mode_of_transport_name} {relDetail.mode === "Air" && | ${relDetail.airline_name}} {relDetail.mode === "Road" && | ${relDetail.transporter_name}} {relDetail.mode === "Train" && | ${relDetail.train_name}} </span> */}
                    </div>
                    <div className="TrBackColor TrBackColor-EM">
                      <span className="fontweightbold">
                        Chargeable Weight in KG
                      </span>{" "}
                      :{" "}
                      <span className="fontweightbold fontweightbold-EM">
                        {relDetail.chargeable_wt}
                      </span>
                    </div>
                    <div className="TrBackColor TrBackColor-EM">
                      <span className="fontweightbold">Crate Size</span> :{" "}
                      <span className="fontweightbold fontweightbold-EM">
                        {relDetail.crate_size}
                      </span>
                    </div>
                  </div>
                </div>

                <div>
                  <table
                    className="table-container"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr className="item-estimate1">
                        <th
                          rowSpan={1}
                          style={{
                            border: "0.4px solid #6A6A6A",
                            width: "51px",
                          }}
                        >
                          S No.
                        </th>
                        <th
                          colSpan={4}
                          style={{ border: "0.4px solid #6A6A6A" }}
                        >
                          Item & Description
                        </th>

                        <th
                          colSpan={1}
                          style={{
                            border: "0.4px solid #6A6A6A",
                            textAlign: "end",
                          }}
                        >
                          Qty.
                        </th>
                        <th
                          colSpan={1}
                          style={{
                            border: "0.4px solid #6A6A6A",
                            textAlign: "end",
                          }}
                        >
                          Rate
                        </th>
                        {hasDiscount && (
                          <th
                            colSpan={1}
                            style={{
                              border: "0.4px solid #6A6A6A",
                              textAlign: "end",
                            }}
                          >
                            Discount
                          </th>
                        )}
                        <th
                          colSpan={1}
                          style={{
                            border: "0.4px solid #6A6A6A",
                            textAlign: "end",
                          }}
                        >
                          Amount excl. GST
                        </th>
                        <th
                          colSpan={1}
                          style={{
                            border: "0.4px solid #6A6A6A",
                            textAlign: "end",
                          }}
                        >
                          Amount incl. GST
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {sow.map((item, index) => {
                        const rowStyle = {
                          backgroundColor:
                            index % 2 === 0 ? "#f5f2f8" : "white",
                          borderRight: "0.4px solid rgb(106, 106, 106)",
                        };

                        const borderStyle = {
                          borderLeft: "0.4px solid #6A6A6A",
                          borderRight: "0.4px solid #6A6A6A",
                        };

                        return (
                          <tr
                            key={index + 1}
                            className="item-estimate"
                            style={rowStyle}
                          >
                            <td
                              colSpan={1}
                              style={{
                                textAlign: "center",
                                borderLeft: " 0.4px solid rgb(106, 106, 106)",
                                borderRight: " 0.4px solid rgb(106, 106, 106)",
                              }}
                            >
                              {index + 1}
                            </td>
                            <td colSpan={4} style={{ fontSize: "13px" }}>
                              {item.description} <br></br>
                              <span style={{ fontSize: "11px", whiteSpace: "pre-line" }}>
                                {item.scope_of_service &&
                                  item.scope_of_service.trim() !== "" && (
                                    <>({item.scope_of_service})</>
                                  )}
                              </span>
                            </td>
                            <td
                              colSpan={1}
                              style={{
                                textAlign: "right",
                                borderLeft: " 0.4px solid rgb(106, 106, 106)",
                                borderRight: " 0.4px solid rgb(106, 106, 106)",
                              }}
                            >
                              {item.quantity}
                            </td>
                            <td colSpan={1} style={{ textAlign: "right" }}>
                              {item.amount_in_inr}
                            </td>
                            {hasDiscount && (
                              <td
                                colSpan={1}
                                style={{
                                  textAlign: "right",
                                  borderLeft: " 0.4px solid rgb(106, 106, 106)",
                                  borderRight: " 0.4px solid rgb(106, 106, 106)",
                                }}
                              >
                                {item.discount || 0}
                              </td>
                            )}
                            <td
                              colSpan={1}
                              style={{
                                textAlign: "right",
                                borderLeft: " 0.4px solid rgb(106, 106, 106)",
                                borderRight: " 0.4px solid rgb(106, 106, 106)",
                              }}
                            >
                              {item.actual_amount}
                            </td>
                            <td
                              colSpan={1}
                              style={{
                                textAlign: "right",
                                borderLeft: " 0.4px solid rgb(106, 106, 106)",
                                borderRight: " 0.4px solid rgb(106, 106, 106)",
                              }}
                            >
                              {item.total}
                            </td>
                          </tr>
                        );
                      })}

                      <tr
                        className="item-estimate item-estimate-border-top"
                        style={{
                          borderRight: "0.4px solid rgb(106, 106, 106)",
                        }}
                      >
                        <td
                          colSpan={hasDiscount ? 7 : 6}
                          className="colSpan5right"
                          style={{
                            borderLeft: "0.4px solid #6A6A6A",
                            borderBottom: "none",
                            fontWeight: 600,
                          }}
                        >
                          Sub Total
                        </td>
                        <td
                          colSpan={2}
                          style={{
                            borderLeft: "0.4px solid #6A6A6A",
                            textAlign: "right",
                          }}
                        >
                          {
                            parseFloat(sow[0]?.estimate_amount_in_inr || 0)
                          }

                        </td>
                        <td
                          colSpan={1}
                          style={{
                            borderLeft: "0.4px solid #6A6A6A",
                            textAlign: "right",
                          }}
                        >
                          {relDetail?.total}
                        </td>
                      </tr>

                      {hasDiscount && (
                        <tr className="TrEstimatechangefont">
                          <td
                            colSpan={hasDiscount ? 7 : 6}
                            style={{
                              borderTop: "0.4px solid #6A6A6A",
                              lineHeight: 1.1,
                              padding: "5px 0 0 0",
                            }}
                          ></td>
                          <td
                            colSpan={1}
                            className="tdDiscount fontweightbold-EM"
                            style={{ borderLeft: "0.4px solid #6A6A6A" }}
                          >
                            Discount
                          </td>
                          <td
                            colSpan={2}
                            className="tdDiscount1"
                            style={{ borderRight: "0.4px solid #6A6A6A" }}
                          >
                            {relDetail?.total_discount}
                          </td>
                        </tr>
                      )}

                      <tr className="TrEstimatechangefont">
                        <td
                          colSpan={hasDiscount ? 7 : 6}
                          style={{
                            borderTop: hasDiscount ? "0.0px solid #6A6A6A" : "0.4px solid #6A6A6A",
                            lineHeight: 1.1,
                            padding: "5px 0 0 0",
                          }}
                        >
                          <div style={{ fontSize: "10.74px" }}>Total In Words</div>
                          <div style={{ marginTop: "-5px" }}>
                            <span style={{ fontSize: "10.85px" }}>
                              {numberToWords(Math.round(relDetail?.finalAfterGateway))} only
                            </span>
                          </div>
                        </td>
                        <td
                          colSpan={1}
                          className="tdDiscount fontweightbold-EM"
                          style={{ borderLeft: "0.4px solid #6A6A6A" }}
                        >
                          GST
                        </td>
                        <td
                          colSpan={1}
                          className="tdDiscount1"
                          style={{ borderRight: "0.4px solid #6A6A6A" }}
                        >
                          {relDetail?.total_gst}
                        </td>
                        <td
                          colSpan={1}
                          className="tdDiscount1"
                          style={{ borderRight: "0.4px solid #6A6A6A" }}
                        >
                        </td>
                      </tr>

                      {hasAdjustment && (
                        <tr>
                          <td className="tdDiscount3" colSpan={hasDiscount ? 7 : 6}>
                            &nbsp;
                          </td>
                          <td
                            className="tdDiscount4"
                            colSpan={1}
                            style={{
                              borderLeft: "0.4px solid #6A6A6A",
                              borderBottom: "0.4px solid #6A6A6A",
                            }}
                          >
                            <span>Discount</span>
                          </td>
                          <td
                            className="tdDiscount5"
                            colSpan={2}
                            style={{
                              borderRight: "0.4px solid #6A6A6A",
                              borderBottom: "0.4px solid #6A6A6A",
                            }}
                          >
                            <span style={{ fontWeight: "600" }}>{relDetail.adjustment}</span>
                          </td>
                        </tr>
                      )}

                      {hasGetwayCharge && (
                        <tr>
                          <td className="tdDiscount3" colSpan={hasDiscount ? 7 : 6}>
                            &nbsp;
                          </td>
                          <td
                            className="tdDiscount4"
                            colSpan={1}
                            style={{
                              borderLeft: "0.4px solid #6A6A6A",
                              borderBottom: "0.4px solid #6A6A6A",
                            }}
                          >
                            <span>Payment Gateway Charges ({relDetail.paymentPercent}%)</span>
                          </td>
                          <td
                            className="tdDiscount5"
                            colSpan={2}
                            style={{
                              borderRight: "0.4px solid #6A6A6A",
                              borderBottom: "0.4px solid #6A6A6A",
                            }}
                          >
                            <span style={{ fontWeight: "600" }}>{relDetail.paymentGatewayCharges}</span>
                          </td>
                        </tr>
                      )}


                      <tr>
                        <td className="tdDiscount3" colSpan={hasDiscount ? 7 : 6}>
                          Notes <br />
                          <span style={{ color: "black" }}>
                            Looking forward for your business
                          </span>
                        </td>
                        <td
                          className="tdDiscount4"
                          colSpan={1}
                          style={{
                            borderLeft: "0.4px solid #6A6A6A",
                            borderBottom: "0.4px solid #6A6A6A",
                          }}
                        >
                          <span>{hasAdjustment ? "Total Payable" : "Total Payable"}</span>
                        </td>
                        <td
                          className="tdDiscount5"
                          colSpan={2}
                          style={{
                            borderRight: "0.4px solid #6A6A6A",
                            borderBottom: "0.4px solid #6A6A6A",
                          }}
                        >
                          <span style={{ fontWeight: "600" }}>
                            {Math.round(relDetail?.finalAfterGateway)}
                          </span>
                        </td>
                      </tr>


                      <tr className="chefontmu">
                        <td colSpan={hasDiscount ? 10 : 9} style={{ padding: "15px 0 9px 0" }}>
                          <table style={{ width: "100%", lineHeight: "1.2" }}>
                            <tbody>
                              <tr className="fontweigthbold">
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    textDecoration: "underline",
                                    fontSize: "12.46px",
                                  }}
                                >
                                  For Payment in INR
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontSize: "11.74px",
                                    color: "black",
                                  }}
                                >
                                  <span
                                    className="fontweigthbold"
                                    style={{ fontSize: "11.74px" }}
                                  >
                                    Bank Name:
                                  </span>{" "}
                                  ICICI BANK
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontSize: "11.74px",
                                    color: "black",
                                  }}
                                >
                                  <span
                                    className="fontweigthbold"
                                    style={{ fontSize: "11.74px" }}
                                  >
                                    A/C Name:
                                  </span>{" "}
                                  DBB WORLDWIDE PVT LTD
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontSize: "11.74px",
                                    color: "black",
                                  }}
                                >
                                  <span
                                    className="fontweigthbold"
                                    style={{ fontSize: "11.74px" }}
                                  >
                                    A/C NO:
                                  </span>{" "}
                                  003705017452
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontSize: "11.74px",
                                    color: "black",
                                  }}
                                >
                                  <span
                                    className="fontweigthbold"
                                    style={{ fontSize: "11.74px" }}
                                  >
                                    IFSC CODE:
                                  </span>{" "}
                                  ICIC0000396
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontSize: "11.74px",
                                    color: "black",
                                  }}
                                >
                                  <span
                                    className="fontweigthbold"
                                    style={{ fontSize: "11.74px" }}
                                  >
                                    BRANCH:
                                  </span>{" "}
                                  SOUTH EXTN. 2, NEW DELHI
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontSize: "11.74px",
                                    color: "black",
                                  }}
                                >
                                  <span
                                    className="fontweigthbold"
                                    style={{ fontSize: "11.74px" }}
                                  >
                                    SWIFT CODE:
                                  </span>{" "}
                                  ICICINBBCTS
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div id="termsContent" style={{ padding: "12px 12px 0px 12px" }}>
                <div className="headerLogo hide-on-screen" id="headerLogo2">
                  <div className="header-right">
                    <div
                      className="logo-container logo-container-wigth"
                      style={{ width: "278px" }}
                    >
                      <img
                        style={{
                          width: "14pc",
                          height: "129px",
                          marginLeft: "38px",
                        }}
                        src={image5}
                        alt="Logo"
                        className="logo logo-container-wigth-img"
                      />
                    </div>
                  </div>
                </div>
                <div style={{ backgroundColor: "#f0f0f0" }}>
                  <table
                    className="chefontmu fontweigthbold-terms"
                    style={{ width: "100%", lineHeight: "1.2" }}
                  >
                    <tbody className="fontweigthbold-terms_tbody">
                      <tr className="fontweigthbold">
                        <td
                          style={{
                            fontWeight: "bold",
                            textDecoration: "underline",
                            fontSize: "12.46px",
                          }}
                        >
                          Terms & Conditions
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: "5px 0 0 0" }}>
                          <span style={{ color: "black" }}>
                            By choosing to relocate your pet with Carry My Pet,
                            you agree to the following terms and conditions:
                          </span>
                          {/* <p> Cargo is subject to Standard Terms and Condition as per IATA
                          Rules and Warsaw Convention.</p> */}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>
                            <FiberManualRecordIcon className="FiberManualRecordIcon_India" />
                          </span>
                          <p>
                            {" "}
                            We are not responsible for flight delays,
                            cancellations, or service restrictions of any kind
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>
                            <FiberManualRecordIcon className="FiberManualRecordIcon_India" />
                          </span>
                          <p>
                            {" "}
                            Quotes are based on your pet’s height, weight, and
                            type and may be subject to change.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>
                            <FiberManualRecordIcon className="FiberManualRecordIcon_India" />{" "}
                          </span>
                          <p>
                            {" "}
                            If incorrect information is provided regarding your
                            pet’s size or weight, additional freight charges may
                            apply.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span style={{ color: "black" }}>
                            Our refund and cancellation policy is available
                            here:{" "}
                            <span style={{ color: "#3498db" }}>
                              https://www.carrymypet.com/refunds-and-cancellations
                            </span>{" "}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table
                    className="chefontmu fontweigthbold-terms"
                    style={{
                      width: "100%",
                      lineHeight: "1.2",
                      marginTop: "10px",
                    }}
                  >
                    <tbody className="fontweigthbold-terms_tbody">
                      <tr className="fontweigthbold">
                        <td
                          style={{
                            fontWeight: "bold",
                            textDecoration: "underline",
                            fontSize: "12.46px",
                          }}
                        >
                          Payment Terms & Conditions
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: "5px 0 0 0" }}>
                          <span>
                            <FiberManualRecordIcon className="FiberManualRecordIcon_India" />{" "}
                          </span>
                          <p>
                            {" "}
                            Cargo is subject to Standard Terms and Condition as
                            per IATA Rules and Warsaw Convention.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>
                            <FiberManualRecordIcon className="FiberManualRecordIcon_India" />
                          </span>
                          <p>
                            {" "}
                            All payments in cash should be made against
                            company's official receipt for the same.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>
                            <FiberManualRecordIcon className="FiberManualRecordIcon_India" />
                          </span>
                          <p>
                            {" "}
                            All payments by Cheque should be crossed 'To Payee's
                            Account Only'.
                          </p>
                        </td>
                      </tr>                      
                      <tr>
                        <td>
                          <span>
                            <FiberManualRecordIcon className="FiberManualRecordIcon_India" />
                          </span>{" "}
                          <p>
                            {" "}
                            No claim and / or discrepancy if any shall be
                            considered unless brought to the notice of the
                            company in writing within 3 days of goods / services
                            and / or the bill.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>
                            <FiberManualRecordIcon className="FiberManualRecordIcon_India" />
                          </span>{" "}
                          <p>
                            {" "}
                            Disputes, if any, shall be subject to the
                            jurisdiction of Delhi, India courts only.
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p
                  style={{
                    textAlign: "center",
                    margin: "118px 0 -19px 0",
                    zIndex: 1,
                    fontSize: "12px",
                  }}
                >
                  "This estimate is electronically generated and does not
                  require a signature"
                </p>
              </div>
            </div>
            <table
              className="table-container fixed-footer"
              style={{ width: "100%", textAlign: "center", bottom: "0" }}
            >
              <tbody style={{ background: "#5b489d", color: "white" }}>
                <tr>
                  <td colSpan={3} style={{ padding: "0 6px 0 6px" }}>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td
                            className="footer1"
                            style={{
                              width: "33.33%",
                              padding: "5px",
                              textAlign: "justify",
                            }}
                          >
                            <i
                              className="fas fa-envelope fasicon"
                              style={{ marginRight: "8px", color: "#ffffff" }}
                            ></i>
                            enquiry@carrymypet.com
                          </td>
                          <td
                            className="footer1"
                            style={{ width: "33.33%", padding: "5px" }}
                          >
                            <i
                              className="fa fa-phone"
                              style={{ marginRight: "8px", color: "#ffffff" }}
                            ></i>
                            +91 8908909020
                          </td>
                          <td
                            className="footer1"
                            style={{
                              width: "33.33%",
                              padding: "5px",
                              textAlign: "end",
                            }}
                          >
                            <i
                              className="fas fa-globe fasicon"
                              style={{ marginRight: "8px", color: "#ffffff" }}
                            ></i>
                            www.carrymypet.com <br /> www.carrymypet.ae
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};


export default EstimateIndia;
